var isNil = require('./isNil');
var isString = require('./isString');

module.exports = function isTypeName(name) {
  return isNil(name) || isString(name);
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/tcomb/lib/isTypeName.js
 ** module id = 502
 ** module chunks = 1
 **/